import * as THREE from 'three';
import { makeMT150Profile } from '../scene/mt150Profiles';
import { applyMetricUVs } from '../scene/materialGeometry';

// A complete CAD sash is shared across every panel instead of extruding N copies.
export function panelArray(group, family, count, panelWidth, height, frame, materials) {
  const batches = [], transforms = new THREE.Object3D();
  const addProfileBatch = (length, placements) => {
    const source = makeMT150Profile(family, 'sash', length, frame, { ...materials, software: false });
    applyMetricUVs(source);
    source.children.forEach(part => {
      const mesh = new THREE.InstancedMesh(part.geometry, part.material, count * placements.length);
      mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
      mesh.castShadow = !materials.software; mesh.receiveShadow = true;
      group.add(mesh); batches.push({ mesh, placements });
    });
  };
  addProfileBatch(panelWidth, [
    { x: 0, y: .042, rx: 0, rz: 0 },
    { x: 0, y: height - .042, rx: Math.PI, rz: 0 },
  ]);
  addProfileBatch(height - .084, [
    { x: -panelWidth / 2, y: height / 2, rx: 0, rz: -Math.PI / 2 },
    { x: panelWidth / 2, y: height / 2, rx: 0, rz: Math.PI / 2 },
  ]);
  const glazing = new THREE.InstancedMesh(new THREE.BoxGeometry(panelWidth - .152, height - .236, .006), materials.glass, count * 2);
  glazing.instanceMatrix.setUsage(THREE.DynamicDrawUsage); group.add(glazing);
  return positions => {
    for (const { mesh, placements } of batches) {
      positions.forEach(({ x, z }, i) => placements.forEach((p, j) => {
        transforms.position.set(x + p.x, p.y, z); transforms.rotation.set(p.rx, 0, p.rz); transforms.updateMatrix();
        mesh.setMatrixAt(i * placements.length + j, transforms.matrix);
      }));
      mesh.instanceMatrix.needsUpdate = true; mesh.computeBoundingSphere();
    }
    positions.forEach(({ x, z }, i) => [-.011, .011].forEach((offset, j) => {
      transforms.position.set(x, height / 2, z + offset); transforms.rotation.set(0, 0, 0); transforms.updateMatrix();
      glazing.setMatrixAt(i * 2 + j, transforms.matrix);
    }));
    glazing.instanceMatrix.needsUpdate = true; glazing.computeBoundingSphere();
  };
}